import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TestApi from './TestApi';
import TeacherList from './pages/TeacherList';
import Academic from './pages/Academic';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { getCurrentTheme } from './config/themeConfig';
import './App.css';

// 受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div>加载中...</div>; // 或者显示一个全局的加载动画
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  // 获取当前主题配置
  const themeConfig = getCurrentTheme();

  return (
    <ConfigProvider locale={zhCN} theme={themeConfig}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/test-api" element={<TestApi />} />
              <Route 
                path="/dashboard/*" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/teacher-list" 
                element={
                  <ProtectedRoute>
                    <TeacherList />
                  </ProtectedRoute>
                }
              />

              <Route 
                path="*" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;